import React, { Component } from "react";
import SortDropdown from "./sortDropdown";

const getText = (current, total_pages, total_results, size, query) =>{
  if(total_results === 0){
    return
  }

  return (`Showing ${(current - 1) * size + 1} to ${
    size > total_results
      ? total_results
      : current * size > total_results
      ? total_results
      : current * size
  } of ${total_results} for "${query}"`)
}
  

class ResultHeader extends Component {
  render() {
    const { current, total_pages, total_results, size } = this.props.info.page;
    return (
      <div className="resultheader-container">
        <div className="resultheader-text">
          {getText(current, total_pages, total_results, size, this.props.q)}
        </div>
        <div className="sort-component-wrapper">
          {/* {
            total_results > 0 && // false because we don't want to display this and we want to be able to revert it
            <SortDropdown sortField={this.props.sortField} app={this.props.app} changeSort={this.props.changeSort} />
          } */}
        </div>
        {/* <div className="sort-component-responsive-wrapper">
          <div onClick={this.props.showResponsiveMenu(true)}>Sort & Filter</div>
        </div> */}
      </div>
    );
  }
}

export default ResultHeader;
